import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Intro {
  constructor() {
    this.element = document.querySelector('.js-intro');
    this.headings = document.querySelectorAll('.intro__heading');

    if (!this.element) {
      return;
    }

    this.visual = this.element.querySelector('.js-intro-visual');
    this.mainElements = this.element.querySelectorAll('.js-intro-main-element');

    gsap.registerPlugin(ScrollTrigger);

    this.siteWidth = 1440;
    this.breakpoint = 1024;

    this.setDimensions = this.setDimensions.bind(this);
    this.checkBreakpoint = this.checkBreakpoint.bind(this);

    this.setDimensions();
    this.init();

    this.setDOMReferences();
  }

  setDOMReferences() {
    window.addEventListener('resize', this.setDimensions);
    window.addEventListener('resize', this.checkBreakpoint);
  }

  setDimensions() {
    const vw = document.documentElement.clientWidth;

    if (vw < this.siteWidth) {
      return;
    }

    const siteWidthOffset = (vw - this.siteWidth) / 2;
    const visualInSitewidth = (this.visual.offsetWidth - siteWidthOffset);
    const maxMainWidth = this.siteWidth - visualInSitewidth;

    for (let i = 0; i < this.mainElements.length; i++) {
      const element = this.mainElements[i];
      element.style.maxWidth = `${maxMainWidth}px`;
    }
  }

  checkBreakpoint() {
    const vw = document.documentElement.clientWidth;

    if (vw <= this.breakpoint) {
      this.scrollTrigger.disable();
    } else {
      this.scrollTrigger.enable();
    }
  }

  init() {
    this.scrollTrigger = ScrollTrigger.create({
      trigger: this.element,
      pin: this.visual,
      start: 'top top',
      end: 'bottom bottom',
    });

    const vw = document.documentElement.clientWidth;
    const scrollTriggerStart = (vw <= this.breakpoint) ? 'top 80%' : '+=600 top';

    gsap.to(document.querySelector('.intro__scroll-trigger'), {
      scrollTrigger: {
        trigger: this.mainElements[0],
        start: scrollTriggerStart,
        toggleActions: 'play complete reverse reset',
      },
      autoAlpha: 0,
    });

    const containers = gsap.utils.toArray('.intro__heading');
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i];

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          pin: true,
          pinSpacing: false,
          scrub: true,
        },
      });

      if (i === 0) {
        tl.to(container, { autoAlpha: 0 }, 0.8);
      } else {
        tl.to(container, { autoAlpha: 1 })
          .to(container, { autoAlpha: 0 }, 0.8);
      }
    }

    this.checkBreakpoint();
  }
}
